import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const ShareLinkIcon = ({ ariaLabel = 'Share link', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className, strokeWidth } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <rect width="32" height="32" rx="4" fill="#6A7785" />
      <path
        d="M21 12C22.6569 12 24 10.6569 24 9C24 7.34315 22.6569 6 21 6C19.3431 6 18 7.34315 18 9C18 10.6569 19.3431 12 21 12Z"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 19C10.6569 19 12 17.6569 12 16C12 14.3431 10.6569 13 9 13C7.34315 13 6 14.3431 6 16C6 17.6569 7.34315 19 9 19Z"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 26C22.6569 26 24 24.6569 24 23C24 21.3431 22.6569 20 21 20C19.3431 20 18 21.3431 18 23C18 24.6569 19.3431 26 21 26Z"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.59 17.51L18.42 21.49"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M18.41 10.51L11.59 14.49"
        stroke="white"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
